import notiStack from './notiStack';

function collectErrorMessages(errorValue, messages) {
  if (!errorValue) {
    return;
  }

  if (Array.isArray(errorValue)) {
    errorValue.forEach(item => collectErrorMessages(item, messages));
    return;
  }

  if (typeof errorValue === 'string') {
    messages.push(errorValue);
    return;
  }

  if (errorValue.message) {
    messages.push(errorValue.message);
    return;
  }

  if (errorValue.messages) {
    collectErrorMessages(errorValue.messages, messages);
    return;
  }

  if (errorValue.errors) {
    collectErrorMessages(errorValue.errors, messages);
  }
}

export function showMutationError(errorValue, fallbackMessage = 'Unable to complete the request.') {
  const messages = [];
  collectErrorMessages(errorValue, messages);

  if (messages.length === 0) {
    notiStack.error(fallbackMessage);
    return false;
  }

  messages.forEach(message => notiStack.error(message));
  return true;
}

function mvMutationErrors(response, returnVar, errors) {
  if (!response) {
    return true;
  }

  if (errors && errors.length > 0) {
    errors.forEach((error) => {
      notiStack.error(`${error.messages}`);
    });
    return true;
  }

  const payload = response[returnVar];
  if (!response) {
    return true;
  }

  if (payload.errors && payload.errors.length > 0) {
    payload.errors.forEach((error) => {
      notiStack.error(`${error.messages}: ${error.field}`);
    });
    return true;
  }
  return false;
}


export function mvOrderErrors(response, returnVar) {
  if (!response) {
    return true;
  }
  const payload = response[returnVar];
  if (!payload) {
    return true;
  }

  if (payload.orderErrors && payload.orderErrors.length > 0) {
    payload.orderErrors.forEach((error) => {
      notiStack.error(`${error.orderIndex}: ${error.message}`);
    });
    return true;
  }
  return false;
}

export default mvMutationErrors;
